import { render } from "./PhoneNumber.vue?vue&type=template&id=78d6a56c&scoped=true"
import script from "./PhoneNumber.vue?vue&type=script&lang=js"
export * from "./PhoneNumber.vue?vue&type=script&lang=js"

import "./PhoneNumber.vue?vue&type=style&index=0&id=78d6a56c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d6a56c"]])

export default __exports__